import { useLocation } from "react-router";

import { useTranslate } from "common/utilities/useTranslate";
import type { Topic } from "entities/topics/types";

type TopicNavigationProps = { id?: string; keyIssueId?: string };

export const getTopicTitle = (topic?: Topic, keyIssue?: Topic) =>
  keyIssue && topic?.id !== keyIssue?.id ? `${topic?.name}: ${keyIssue?.name}` : topic?.name;

export const useTopicNavigation = (props?: TopicNavigationProps) => {
  const translate = useTranslate();
  const location = useLocation();
  const isCreate = location.pathname.includes("create");
  const domain = isCreate ? "create" : "topics";
  const label = translate(isCreate ? "app.create.title" : "app.discover.title");
  let path = `/${domain}`;
  if (props?.id) {
    path += `/${props.id}`;
  }
  if (props?.keyIssueId) {
    path += `/key-issues/${props.keyIssueId}`;
  }
  return { path, label };
};

export const getTopicCurator = (topic: Topic) => {
  if (topic.co_curator) {
    return topic.co_curator;
  } else if (topic.is_custom) {
    return topic.provider?.name ?? "";
  }
  return "World Economic Forum";
};
